import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Layout',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
